var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classNames},[_c('ins',{staticClass:"adsbygoogle",style:({display: 'block'}),attrs:{"data-ad-format":"fluid","data-ad-layout-key":_vm.layoutKey,"data-ad-client":_vm.googleAdId,"data-ad-slot":_vm.slotId}})])}
var staticRenderFns = []

export { render, staticRenderFns }